import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../Styles/Components.less";
import { Checkbox } from "antd";
import { BulbOutlined, MessageOutlined } from "@ant-design/icons";
import MainPage from "./MainPage";
import { AppStorageKeys } from "../Constants/Constants";
import LocalStorage from "../Constants/LocalStorage";

class TipsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideTechTips: LocalStorage.get(AppStorageKeys.tipTech) || false,
      hideMessageTips: LocalStorage.get(AppStorageKeys.tipMessage) || false,
    };
  }

  onMessageTipChange = (e) => {
    const value = e?.target?.checked;
    this.setState({ hideMessageTips: value });
    LocalStorage.set(AppStorageKeys.tipMessage, value);
  };

  onTechTipChange = (e) => {
    const value = e?.target?.checked;
    this.setState({ hideTechTips: value });
    LocalStorage.set(AppStorageKeys.tipTech, value);
  };

  render() {
    const { hideTechTips, hideMessageTips } = this.state;

    return (
      <MainPage>
        <div className="tips-container">
          <div className="box-container">
            <div className="box-header">
              <div className="box-header-container">
                <MessageOutlined className="header-logo" />
                <span className="header-title">MESSAGE OF THE DAY</span>
              </div>
              <Checkbox
                checked={hideMessageTips}
                onChange={this.onMessageTipChange}
              >
                don't show after login
              </Checkbox>
            </div>
            <div className="box-content"></div>
          </div>
          <div className="box-container box-spacing">
            <div className="box-header">
              <div className="box-header-container">
                <BulbOutlined className="header-logo" />
                <span className="header-title">TECH TIPS</span>
              </div>
              <Checkbox checked={hideTechTips} onChange={this.onTechTipChange}>
                don't show after login
              </Checkbox>
            </div>
            <div className="box-content"></div>
          </div>
        </div>
      </MainPage>
    );
  }
}

TipsPage.propTypes = {};

const mapStateToProps = (state) => ({});
const connectedTipsPage = connect(mapStateToProps)(TipsPage);
export default withRouter(connectedTipsPage);
